/**
 * @generated SignedSource<<4b7ae1949c884e498dc89d6afa498a3e>>
 * @relayHash ac126ab6ad51eb7e97d13f8b95bc4ec6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac126ab6ad51eb7e97d13f8b95bc4ec6

import type { ConcreteRequest } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type PullRequestAndBranchPickerSearchQuery$variables = {
  assignee: string;
  author: string;
  commenters: string;
  first?: number | null | undefined;
  mentions: string;
  open: string;
  queryIsUrl: boolean;
  resource: string;
};
export type PullRequestAndBranchPickerSearchQuery$data = {
  readonly assignee: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PullRequest";
      readonly createdAt: string;
      readonly id: string;
      readonly isDraft: boolean;
      readonly isInMergeQueue: boolean;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly author: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PullRequest";
      readonly createdAt: string;
      readonly id: string;
      readonly isDraft: boolean;
      readonly isInMergeQueue: boolean;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly commenters: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PullRequest";
      readonly createdAt: string;
      readonly id: string;
      readonly isDraft: boolean;
      readonly isInMergeQueue: boolean;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly mentions: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PullRequest";
      readonly createdAt: string;
      readonly id: string;
      readonly isDraft: boolean;
      readonly isInMergeQueue: boolean;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly open: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: "PullRequest";
      readonly createdAt: string;
      readonly id: string;
      readonly isDraft: boolean;
      readonly isInMergeQueue: boolean;
      readonly number: number;
      readonly repository: {
        readonly id: string;
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly __typename: string;
          readonly id: string;
          readonly login: string;
        };
      };
      readonly state: PullRequestState;
      readonly title: string;
      readonly url: string;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined> | null | undefined;
  };
  readonly resource?: {
    readonly __typename: "PullRequest";
    readonly createdAt: string;
    readonly id: string;
    readonly isDraft: boolean;
    readonly isInMergeQueue: boolean;
    readonly number: number;
    readonly repository: {
      readonly id: string;
      readonly name: string;
      readonly nameWithOwner: string;
      readonly owner: {
        readonly __typename: string;
        readonly id: string;
        readonly login: string;
      };
    };
    readonly state: PullRequestState;
    readonly title: string;
    readonly url: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type PullRequestAndBranchPickerSearchQuery = {
  response: PullRequestAndBranchPickerSearchQuery$data;
  variables: PullRequestAndBranchPickerSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assignee"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "author"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commenters"
},
v3 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "mentions"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "open"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryIsUrl"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resource"
},
v8 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v9 = {
  "kind": "Literal",
  "name": "type",
  "value": "ISSUE"
},
v10 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "commenters"
  },
  (v9/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v11/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "login",
          "storageKey": null
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/),
      (v19/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v22 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": (v21/*: any*/),
    "storageKey": null
  }
],
v23 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "mentions"
  },
  (v9/*: any*/)
],
v24 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "assignee"
  },
  (v9/*: any*/)
],
v25 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "author"
  },
  (v9/*: any*/)
],
v26 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "open"
  },
  (v9/*: any*/)
],
v27 = [
  {
    "kind": "Variable",
    "name": "url",
    "variableName": "resource"
  }
],
v28 = [
  (v19/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v20/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v11/*: any*/)
    ],
    "type": "Node",
    "abstractKey": "__isNode"
  }
],
v29 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": (v28/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PullRequestAndBranchPickerSearchQuery",
    "selections": [
      {
        "alias": "commenters",
        "args": (v10/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": null
      },
      {
        "alias": "mentions",
        "args": (v23/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": null
      },
      {
        "alias": "assignee",
        "args": (v24/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": null
      },
      {
        "alias": "author",
        "args": (v25/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": null
      },
      {
        "alias": "open",
        "args": (v26/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": null
      },
      {
        "condition": "queryIsUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v27/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": (v21/*: any*/),
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v4/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "PullRequestAndBranchPickerSearchQuery",
    "selections": [
      {
        "alias": "commenters",
        "args": (v10/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v29/*: any*/),
        "storageKey": null
      },
      {
        "alias": "mentions",
        "args": (v23/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v29/*: any*/),
        "storageKey": null
      },
      {
        "alias": "assignee",
        "args": (v24/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v29/*: any*/),
        "storageKey": null
      },
      {
        "alias": "author",
        "args": (v25/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v29/*: any*/),
        "storageKey": null
      },
      {
        "alias": "open",
        "args": (v26/*: any*/),
        "concreteType": "SearchResultItemConnection",
        "kind": "LinkedField",
        "name": "search",
        "plural": false,
        "selections": (v29/*: any*/),
        "storageKey": null
      },
      {
        "condition": "queryIsUrl",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": (v27/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "resource",
            "plural": false,
            "selections": (v28/*: any*/),
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ac126ab6ad51eb7e97d13f8b95bc4ec6",
    "metadata": {},
    "name": "PullRequestAndBranchPickerSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9a844ac496ab2eb531790b5ca58b724a";

export default node;
